import { DetailAction } from './DetailAction';
import { Backend } from '../../../api/Backend';
import { AssetType } from '../../../api/models/Shared.types';
import { Lightning } from '@lightningjs/sdk';

export class ToggleReminderAction extends DetailAction {
  private _id: string;
  private _type: AssetType;
  private readonly _callback?: (val: boolean) => void;

  constructor(backend: Backend, id: string, type: AssetType, callback?: (val: boolean) => void) {
    super(backend);
    this._id = id;
    this._type = type;
    this._callback = callback;

    backend.cachedReminderApi.hasReminder(backend, id).then((val: boolean) => {
      callback?.(val);
    });
  }

  override doAction(modalOwner: Lightning.Component | undefined = undefined) {
    this._backend.cachedReminderApi.toggleReminder(this._backend, this._type, this._id).then((bool: boolean) => {
      this._callback?.(bool);
      if (!bool && modalOwner) modalOwner.fireAncestors('$removeReminderCard', modalOwner);
    });
  }
}
